import clsx from "clsx";
import { Link } from "react-router-dom";
import WhiteButton from "../../buttons/WhiteButton";
import ArrowUpRight from "../../icons/ArrowUpRight";
import ImagesCaroussel from "../../assets/ImagesCaroussel";
import useGlobalStore from "../../../store/useGlobalStore";
import { useHover } from "@uidotdev/usehooks";
import { useEffect } from "react";
import { useMediaQuery } from "react-responsive";

function StickySection(
    {
        title = "",
        skills = [],
        catch_phrase = "",
        text = "",
        buttons = [],
        images = [],
        textClassName,
        buttonClassName,
        reversed = false
    }
) {
    const globalStore = useGlobalStore();

    const [carousselRef,hovering] = useHover();

    const isMobile = useMediaQuery(
        {
            query: "(max-width: 780px)"
        }
    )

    useEffect(()=>{
        if(images.length > 0 && images[0].post_slug){
            if(hovering){
                globalStore.setCursorPopupText("Voir ce Projet");
                globalStore.setCursorPopupActive(true);
            } else {
                globalStore.setCursorPopupActive(false);
            }
        }
    },[hovering]);
    return (
        <div className={clsx(
            "flex overflow-hidden sticky top-[105px] mobile:top-[72px] left-0 text-white tablet:!flex-col-reverse",
            reversed && "flex-row-reverse"
        )} style={
            {
                minHeight: isMobile ? "calc(100dvh - 72px)" : "calc(100dvh - 105px)",
                maxHeight: isMobile ? "calc(100dvh - 72px)" : "calc(100dvh - 105px)"
            }
        }>
            <div className={clsx(
                "basis-1/2 min-h-full self-stretch flex flex-col items-center justify-center p-12 tablet:grow",
                textClassName
            )}>
                <div className="flex flex-col gap-[4.6875rem] mobile:gap-[1rem] max-w-[750px]">
                    <div className="flex flex-col gap-[0.875rem]">
                        <h2 className="text-heading-2 uppercase font-[600] mobile:text-heading-3">
                            {title}
                        </h2>
                        <ul className="flex gap-[1.375rem] items-center flex-wrap">
                            {skills.map((v,index)=>
                            <>
                            <li className="text-[500] whitespace-nowrap">{v}</li>
                            {index<skills.length-1 && <li className="block w-[6px] h-[6px] rounded-full bg-white"></li>}
                            </>)}
                        </ul>
                    </div>
                    <div className="flex flex-col gap-[3.375rem] mobile:gap-[2rem]">
                        <h3 className="text-heading-6 font-[700] mobile:text-very-large">
                            "{catch_phrase}"
                        </h3>
                        <p className="text-large">
                            {text}
                        </p>
                        {buttons.length > 0 && 
                        <div className="w-full flex gap-[1.875rem] flex-wrap">
                            {buttons.map(button=>
                                <Link to={button.href} className="w-fit">
                                    <WhiteButton className={clsx(
                                        "w-fit",
                                        buttonClassName
                                    )} icon={<ArrowUpRight/>}>
                                        {button.label}
                                    </WhiteButton>
                                </Link>
                            )}
                        </div>}
                    </div>
                </div>
            </div>
            <div className="basis-1/2 min-h-full max-h-full tablet:min-h-auto tablet:w-full overflow-hidden">
                <div className="w-full h-full max-h-[925px] overflow-hidden object-cover tablet:h-auto tablet:aspect-[16/9] tablet:max-h-[250px]" ref={carousselRef}>
                    <ImagesCaroussel images={images} navigation={true}/>
                </div>
            </div>
        </div>
    )
}
export default function StickySections({
    sections = []
}) {
    const classNames = [
        "bg-zoeil-blue",
        "bg-zoeil-pink",
        "bg-zoeil-light-blue",
        "bg-zoeil-yellow"
    ];

    const buttonsClassNames = [
        "text-zoeil-blue",
        "text-zoeil-pink",
        "text-zoeil-light-blue",
        "text-zoeil-yellow"
    ]


    return (
        <div>
            {sections.map((v, index) => <StickySection {...v} textClassName={clsx(
                classNames[index % classNames.length]
            )} reversed={index % 2 !== 0} buttonClassName={buttonsClassNames[index % buttonsClassNames.length]}/>)}
        </div>
    )
}